/**
 * HeaderFooterPreviewPage — /p/hf-preview route.
 * Loaded in the admin Header/Footer editor's iframe.
 * Listens for ARCEE_HF_SCHEMA postMessage and renders the real
 * DynamicHeader and DynamicFooter so the preview matches the client portal.
 */

import React, { useEffect, useState } from 'react';
import { useTheme } from '../theme/ThemeContext';
import DynamicHeader from '../components/DynamicHeader';
import PublicHeader from '../components/public/PublicHeader';
import DynamicFooter from '../components/dynamic-page/DynamicFooter';

export default function HeaderFooterPreviewPage() {
  const { theme, setTheme, themesList } = useTheme();
  const [headerCfg, setHeaderCfg] = useState(null);
  const [footerCfg, setFooterCfg] = useState(null);
  const [showHeader, setShowHeader] = useState(true);
  const [useAppHeader, setUseAppHeader] = useState(false);

  useEffect(() => {
    // Notify the parent admin frame that we're ready to receive config
    window.parent.postMessage({ type: 'ARCEE_HF_READY' }, '*');

    const handler = (event) => {
      if (event.data?.type !== 'ARCEE_HF_SCHEMA') return;
      const { header, footer, theme: themeData, show_header, use_app_header } = event.data;
      if (show_header !== undefined) setShowHeader(show_header !== false);
      if (use_app_header !== undefined) setUseAppHeader(use_app_header === true);
      if (header !== undefined) setHeaderCfg(header);
      if (footer !== undefined) setFooterCfg(footer);
      if (themeData) {
        const match = themesList?.find(t => t.name === themeData.name);
        if (match) {
          setTheme(match);
        } else if (themeData.primary) {
          const root = document.documentElement;
          root.style.setProperty('--primary-color', themeData.primary);
          if (themeData.secondary) root.style.setProperty('--secondary-color', themeData.secondary);
          if (themeData.gradientBackground) root.style.setProperty('--gradient-bg', themeData.gradientBackground);
        }
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [setTheme, themesList]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f8fafc' }}>

      {/* The real component, so the editor shows what the page will actually
          draw: the brand bar — logo and app name, nothing else. */}
      {showHeader && useAppHeader && <PublicHeader brandOnly />}

      {showHeader && !useAppHeader && headerCfg && <DynamicHeader headerConfig={headerCfg} appBranding={{}} />}

      {/* Placeholder page body */}
      <div style={{ flex: 1, padding: '40px 32px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ height: 14, background: '#e2e8f0', borderRadius: 6, width: '55%' }} />
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 6, width: '78%' }} />
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 6, width: '48%' }} />
        <div style={{ height: 90, background: '#f1f5f9', borderRadius: 10, marginTop: 8, border: '1px solid #e2e8f0' }} />
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 6, width: '68%' }} />
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 6, width: '42%' }} />
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 6, width: '60%' }} />
      </div>

      {footerCfg && <DynamicFooter footerCfg={footerCfg} theme={theme} />}
    </div>
  );
}
